import React, { Fragment } from 'react';
import { Popover, PopoverButton, PopoverPanel, Transition } from '@headlessui/react';
import { useDispatch, useSelector } from 'react-redux';
import NotificationButton from '../NotificationButton/NotificationButton';
import NotificationDropdownPanel from './NotificationDropdownPanel';
import {
  fetchNotificationPreview,
  fetchUnreadNotificationCount,
  selectHasUnreadNotifications,
} from 'store/slices/notificationsSlice';

export default function NotificationDropdown({ count = 0 }) {
  const dispatch = useDispatch();
  const hasUnread = useSelector(selectHasUnreadNotifications);

  const handleToggle = (isOpen) => {
    if (isOpen) {
      return;
    }

    dispatch(fetchNotificationPreview());
    dispatch(fetchUnreadNotificationCount());
  };

  return (
    <Popover className="relative">
      {({ open, close }) => (
        <>
          <PopoverButton
            as={NotificationButton}
            count={count}
            showDot={hasUnread && count === 0}
            isOpen={open}
            onClick={() => handleToggle(open)}
          />

          <Transition
            as={Fragment}
            enter="transition duration-150 ease-out"
            enterFrom="translate-y-1 opacity-0"
            enterTo="translate-y-0 opacity-100"
            leave="transition duration-100 ease-in"
            leaveFrom="translate-y-0 opacity-100"
            leaveTo="translate-y-1 opacity-0"
          >
            <PopoverPanel className="absolute right-0 z-50 mt-2 w-screen max-w-sm rounded-md bg-gray-800 shadow-lg ring-1 ring-white/10">
              <NotificationDropdownPanel onClose={close} />
            </PopoverPanel>
          </Transition>
        </>
      )}
    </Popover>
  );
}
